import React from 'react'
import cn from 'classnames'
import { ReactComponent as RingtoneIcon } from 'assets/svg/settings/ringtone.svg'
import { ReactComponent as RingtoneDeviceIcon } from 'assets/svg/settings/ringtone-device.svg'
import { ReactComponent as MicrophoneIcon } from 'assets/svg/settings/microphone.svg'
import { ReactComponent as SpeakersIcon } from 'assets/svg/settings/speakers.svg'
import { ReactComponent as ArrowDownIcon } from 'assets/svg/shared/arrow_down.svg'
import { useTranslation } from 'react-i18next'

const paramIcon = (icon) => {
    switch (icon) {
        case 'ringtone':
            return <RingtoneIcon />
        case 'output':
            return <SpeakersIcon />
        case 'ringing_device':
            return <RingtoneDeviceIcon />
        case 'microphone':
            return <MicrophoneIcon />
        default:
            return null
    }
}

export const SettingBlock = ({
    title,
    value,
    children,
    fieldText,
    icon,
    buttonRef,
    config,
    configName,
    toggleModal,
    withOutMarginBottom = false
}) => {
    const { t } = useTranslation()

    return (
        <div className={cn('sound-and-devices', !withOutMarginBottom && 'has-margin-bottom')}>
            {title && <span className="sound-and-devices__title">{title}</span>}
            <div className="sound-and-devices__item">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="sound-and-devices__item-label d-flex align-items-center">
                        {paramIcon(icon)}
                        <span>{fieldText}</span>
                    </div>
                    <button
                        type="button"
                        ref={buttonRef}
                        className="sound-and-devices__item-btn d-flex align-items-center"
                        onClick={(e) => toggleModal(e, buttonRef, config, configName)}
                    >
                        {t(config.find(({ id }) => id === value)?.name)} <ArrowDownIcon />
                    </button>
                </div>
                {children}
            </div>
        </div>
    )
}
